import { loadNamespaces } from 'i18next';
import { dispatch } from 'src/redux/store';
import { finishWaiting, startWaiting } from 'src/redux/uiSlice';

export const loadNamespace = async () => {
  dispatch(startWaiting());
  await loadNamespaces('app');
  dispatch(finishWaiting());
};
